import IconCopy from 'assets/img/icons/copy.svg';
import SettingMenu from 'components/company/revamp/parts/setting/content';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Button from 'components/_parts/atoms/button';

function Setting() {
  const { t } = useTranslation();
  const { companyCode } = useSelector((state) => ({
    companyCode: state?.company?.detail?.company_code,
  }));
  return (
    <>
      <div
        className="company_code !tw-pb-[15px]"
      >
        <Button
          className="btn_custom"
          style={{
            backgroundColor: '#9AFF5B',
            padding: '0px 18px',
            gap: '30px',
            height: '24px',
          }}
          func={() => {
            navigator.clipboard
              .writeText(companyCode)
              .then(() => {
                toast.success(t('company.code_copied'));
              })
              .catch(() => {
                toast.error(t('company.code_not_copied'));
              });
          }}
        >
          {companyCode}
          <span>
            <img src={IconCopy} alt="copy-id" />
          </span>
        </Button>
      </div>
      <div className="d-flex flex-column">
        <SettingMenu />
      </div>
    </>
  );
}

export default Setting;
